// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UWoX","right":"styles_right__21RcF"};